exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".order-no[data-v-88d8f372]{background-color:#82ba1d;color:#fff;font-size:.9rem;font-weight:700;padding:.1rem .5rem}.end-at[data-v-88d8f372],.event-name[data-v-88d8f372]{background-color:#fff;border-collapse:collapse;border:1px solid #82ba1d;font-size:.8rem;padding:.1rem .2rem}.end-at .info-label[data-v-88d8f372],.event-name .info-label[data-v-88d8f372]{color:#82ba1d;font-weight:700}.price-area[data-v-88d8f372]{background-color:#fff;border:1px solid #7bb600;padding:.5rem 1rem}.price-info-wrap[data-v-88d8f372]{border:1px solid #ec4200;background-color:#fff;position:relative}.price-info-wrap .price-info .price-label[data-v-88d8f372]{padding:1px 4px 0;color:#ec4200}.price-info-wrap .price-info .price-value[data-v-88d8f372]{font-size:1.2rem;padding:0 4px}.size-info-mobile[data-v-88d8f372]{font-size:.7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-88d8f372&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/subPages/Order/Confirm.vue
// module id = 529
// module chunks = 0